import React from 'react';
import PropTypes from 'prop-types';
import AccordionDataSection from './AccordionDataSection';
import { Section, TitleSection, TooltipElement } from './style';

const AccordionSection = ({ className, title, dataSection }) => (
  <Section className={className}>
    <TitleSection>
      <TooltipElement text={title} />
    </TitleSection>
    {dataSection &&
      dataSection.map((item, i) => (
        <AccordionDataSection
          title={item.title}
          body={item.body}
          span={item.span}
          key={`datasection-${i + 1}`}
        />
      ))}
  </Section>
);

AccordionSection.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string,
  dataSection: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      body: PropTypes.string
    })
  )
};

export default AccordionSection;
